import type { SupporterVoicesFeedItem } from './api';

/**
 * Mirrors the comment anonymization in `../anonymizeForBots.ts`. Video items aren't anonymized
 * here: `PetitionSupporterVideo` only ever exposes `shortDisplayName` (no displayName/city/photo),
 * and the pre-existing `petitionSupporterVideos` fetch it used to come from never anonymized that
 * field either, so there's no new exposure to guard against.
 */
export function anonymizeSupporterVoicesFeedForBots(
	feed: readonly SupporterVoicesFeedItem[],
): readonly SupporterVoicesFeedItem[] {
	return feed.map((item) => {
		if (item.__typename !== 'PetitionSupporterComment') return item;

		return {
			...item,
			user: {
				...item.user,
				displayName: item.user.firstName,
				shortDisplayName: item.user.firstName,
				city: null,
				photo: null,
			},
		};
	});
}
